import React from 'react';
import { Spinner } from 'react-bootstrap';
import './backdrop.scss';

const ResponceForAPI = ({ show }) => (
  <div className={`backdropRes ${show ? 'show' : ''}`} style={{flexDirection:'column'}}>
   
    <div class="custom-loader"></div>
  <span style={{marginTop:'5px'}}>  Invoice Processing</span>
  </div>
);

export default ResponceForAPI;